export const photoGallery = {
  "photoGallery.section.get": "photoGallery.section.get",
  "photoGallery.section.create": "photoGallery.section.create",
  "photoGallery.section.update": "photoGallery.section.update",
  "photoGallery.section.delete": "photoGallery.section.delete",
} as const;
